
import React from 'react';
import { Link } from 'react-router-dom';

const ContactPage: React.FC = () => (
    <div className="pt-20 bg-gray-50 min-h-screen">
        <header className="bg-white py-16 text-center border-b">
            <div className="container mx-auto px-6">
                <h1 className="text-4xl md:text-5xl font-extrabold text-[#3aabd2]">Contact</h1>
                <p className="mt-2 text-lg text-gray-600">お問い合わせ</p>
            </div>
        </header>
        <section className="py-20">
            <div className="container mx-auto px-6">
                <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-lg border border-gray-200">
                    <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label htmlFor="company-name" className="block text-sm font-medium text-gray-700">会社・組織名</label>
                            <input type="text" id="company-name" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#3aabd2] focus:border-[#3aabd2]" placeholder="例：株式会社AgLab" required />
                        </div>
                        <div>
                            <label htmlFor="department" className="block text-sm font-medium text-gray-700">部署名</label>
                            <input type="text" id="department" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#3aabd2] focus:border-[#3aabd2]" placeholder="部署名" />
                        </div>
                        <div>
                            <label htmlFor="position" className="block text-sm font-medium text-gray-700">役職</label>
                            <input type="text" id="position" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#3aabd2] focus:border-[#3aabd2]" placeholder="例：部長" />
                        </div>
                        <div>
                            <label htmlFor="contact-person" className="block text-sm font-medium text-gray-700">担当者名</label>
                            <input type="text" id="contact-person" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#3aabd2] focus:border-[#3aabd2]" placeholder="例：山田 太郎" required />
                        </div>
                        <div>
                            <label htmlFor="phone" className="block text-sm font-medium text-gray-700">電話番号</label>
                            <input type="tel" id="phone" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#3aabd2] focus:border-[#3aabd2]" placeholder="例：01234567890" required />
                        </div>
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">メールアドレス</label>
                            <input type="email" id="email" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#3aabd2] focus:border-[#3aabd2]" placeholder="例：sample@sample.jp" required />
                        </div>
                        <div className="md:col-span-2">
                            <label htmlFor="message" className="block text-sm font-medium text-gray-700">問い合わせ内容</label>
                            <textarea id="message" rows={5} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#3aabd2] focus:border-[#3aabd2]" placeholder="お問い合わせ内容をご記入してください。" required></textarea>
                        </div>
                        <div className="md:col-span-2 flex flex-col items-center">
                            <div className="flex items-center space-x-2">
                                 <input id="privacy-checkbox" type="checkbox" className="h-4 w-4 text-[#3aabd2] focus:ring-[#3aabd2] border-gray-300 rounded" required />
                                 <label htmlFor="privacy-checkbox" className="text-sm text-gray-600">プライバシーポリシーに同意する</label>
                            </div>
                            <Link to="/privacy-policy" className="text-sm text-[#3aabd2] hover:underline mt-1">プライバシーポリシー</Link>
                        </div>
                        <div className="md:col-span-2 text-center">
                            <button type="submit" className="inline-flex justify-center py-3 px-8 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-[#3aabd2] hover:bg-[#2f8faf] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3aabd2] transition-all duration-300">
                                この内容で送信する
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
);

export default ContactPage;
